/* eslint-disable @typescript-eslint/ban-ts-comment */
import axios, { AxiosResponse } from 'axios'
import { useState } from 'react'
import { ServiceError, ServiceResponse } from '../interfaces/services.interface'
import { useAppSelector } from './redux'
import { selectRegisterInfo } from '../redux/slices/authSlice'

export default <T>(
    apiFunc: (...args: any[]) => Promise<AxiosResponse<ServiceResponse<T> | T>>
) => {
    const [data, setData] = useState<T>()
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    // Redux
    const registerInfo = useAppSelector(selectRegisterInfo)

    const request = async (...args: any[]) => {
        setLoading(true)
        try {
            setError('')
            setData(undefined)
            const result = await apiFunc(...args)
            // @ts-ignore
            if (result.data && 'data' in result.data) {
                setData(result.data.data)
            } else {
                setData(result.data)
            }
            return result.data
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const errMsg = (err.response?.data as ServiceError)?.message

                // Log for 500 errors
                // if (
                //     err.response &&
                //     err.response.status >= 500 &&
                //     err.response.status <= 599
                // ) {
                //     // Send Request and response to sentry
                //     const scope = new Sentry.Scope()
                //     if (registerInfo) {
                //         scope.setUser({
                //             username: registerInfo.nationalCode ?? '',
                //             id: registerInfo.phoneNumber ?? '',
                //         })
                //     }
                //     scope.setTags({
                //         type: 'service',
                //         path: err.config?.url,
                //         method: err.config?.method,
                //     })
                //     if (err.config?.url) {
                //         scope.setContext('api', {
                //             path: err.config.url,
                //             baseUrl: err.config.baseURL,
                //             requestData: err.config.data,
                //             requestHeader: err.config.headers,
                //             response: err.response.data,
                //         })
                //     }
                //     Sentry.captureException(err, () => scope)
                // }

                if (errMsg) {
                    setError(errMsg)
                    throw new Error(errMsg)
                } else {
                    setError('خطایی رخ داده است!')
                }
            } else if (err instanceof Error) {
                // A TypeError
                setError(err.message)
            } else {
                // everything else
                setError('خطایی رخ داده است!')
            }
            throw err
        } finally {
            setLoading(false)
        }
    }

    return {
        data,
        error,
        loading,
        request,
    }
}
